module.exports = __webpack_public_path__ + "img/expand-icon.80db28d2.svg";